module.exports = __webpack_public_path__ + "static/logo.d1ec98d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 1323
// module chunks = 114276838955818